// eslint-disable-next-line import/extensions
import YkcWarningTips from './src/main.js';
/**
 *@author huhongyun
 *@date 2021/10/13
 *@component YkcWarningTips - 告警提示组件
 */
export default YkcWarningTips;
